export default class TrackingService {
  public static TrackEvent(path: string, title: string) {
    try {
      // Tracking!
      const x = (window as any)?.goatcounter;
      const trackEvent = {
        path,
        title,
        event: true
      };
      console.debug("Track event...", trackEvent);
      x?.count(trackEvent);
    } catch {
      // Ignore silently...
    }
  }
}
